import { useMemo, useState } from 'react'

import { useSearchEventForEmbed } from '@tribeplatform/react-sdk/hooks'
import { useDebounce } from '@tribeplatform/react-ui-kit/hooks'

export const useSearchEvents = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedSearchQuery = useDebounce(searchQuery, 500)

  const { data: searchData, isLoading: isSearchLoading } =
    useSearchEventForEmbed({
      variables: {
        query: debouncedSearchQuery,
        limit: 20,
      },
      useInfiniteQueryOptions: {
        enabled: !!debouncedSearchQuery,
      },
    })

  const searchedEventIds = useMemo(() => {
    if (!debouncedSearchQuery) {
      return []
    }
    return Array.from(
      new Set(
        searchData?.pages
          .flatMap(page => page.nodes)
          .map(event => event?.recurrenceId)
          .filter(Boolean) || [],
      ),
    )
  }, [searchData, debouncedSearchQuery])

  return {
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery,
    searchedEventIds,
    isSearchLoading,
  }
}
